import { z } from "zod"

// A finite % still compounds to Infinity (value/100 × projected), and Math.max(0, NaN) is NaN.
export const MAX_ADJUSTMENT_PERCENT = 1_000_000

// Same guard for `add` rows: two finite ones can still sum to Infinity. Headroom, not a real limit.
// Also caps pinned totals: publish writes `real` columns, which overflow far below a double's range.
export const MAX_ADJUSTMENT_ADD = 1_000_000_000

/** Units up to `MAX_ADJUSTMENT_ADD`, refused above it with "<noun> can't be more than … units". */
export const unitsUpToCap = (noun: string) =>
  z
    .number()
    .finite()
    .max(MAX_ADJUSTMENT_ADD, {
      message: `${noun} can't be more than ${MAX_ADJUSTMENT_ADD.toLocaleString("en-US")} units`,
    })

export const MAX_ADJUSTMENT_IDS = 1_000

// Kysely's `.values()` binds one param per column per row, so an unbounded per-variant payload can
// reach Postgres' 65535-parameter ceiling.
export const MAX_PER_VARIANT_ROWS = 1_000

// A guard, not a working limit: an edit reads back only the slices on screen.
export const MAX_READBACK_SLICES = 8

export const CollectionIdsSchema = z.array(z.number()).min(1)

// No `.min(1)`: callers read an empty array as "fall back to collectionIds".
export const SourceCollectionIdsSchema = z.array(z.number()).nullish()

export const VariantScopeSchema = z.union([
  z.object({ variantIds: z.array(z.string()).min(1) }),
  z.object({ collectionIds: CollectionIdsSchema }),
])

// Omitted axes default to the "all" sentinels (Total scope).
export const scopeFields = {
  channel: z.string().default(""),
  warehouseId: z.string().default(""),
  marketId: z.string().default(""),
}
